module.exports = "/_next/static/images/technologyDeploymentBg-2c08185d3248952faf869a1ebb1b7da1.webp";